export enum Supplier {
  teraseya = 'Teraseya',
  customer = 'Customer',
}
